import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';
import { getAsidePanelIsMobile } from '../../aside_panel/asidePanel/store/selectors/getAsidePanelIsMobile';
import { getNavigationPanelState } from '../../main/navigationPanel/store/selectors/getNavigationPanelState';
import { ENavigationPanelTypes } from '../../main/navigationPanel/constants';

export const pushNotificationsCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.PUSH_NOTIFICATIONS);
    if (!hint) return false;

    const canShow = getHintCanShow(state, EHintKey.PUSH_NOTIFICATIONS);
    if(!canShow) return false;

    const navPanel = getNavigationPanelState(state);
    return navPanel && navPanel.panelType === ENavigationPanelTypes.NP_BIG_TYPE ||
        navPanel.panelType === ENavigationPanelTypes.NP_MOBILE_TYPE && navPanel.isOpen;
};
